import { environment } from 'src/environments/environment';
import { assert } from '../utils/assert.util';

export const ASSET_URL_BASE = environment.assetsURL;
export const getDevAssetURL = (bucket: string, parentBucket: string = 'ns-uploads') => `${ASSET_URL_BASE}/${parentBucket}/${bucket}`;
export const getProdAssetURL = (bucket: string, parentBucket: string = 'ns-uploads') => `${ASSET_URL_BASE}/${parentBucket}/${bucket}`;
export const getAssetURL = (bucket: string, parentBucket: string = 'ns-uploads') => getDevAssetURL(bucket, parentBucket);
export const getAWSAssetURL = (bucket: string) => { assert(environment.awsURL, 'No aws url'); return `${environment.awsURL}/${bucket}`; }